import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Drawer,
  IconButton,
  Divider,
  Typography,
} from '@mui/material';
import {
  FaTachometerAlt,
 
  FaIdBadge,
  FaUserCircle,
 
  FaCalendarAlt,
  
} from 'react-icons/fa';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../assets/logo.svg';

function Sidebar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { text: 'Dashboard', icon: <FaTachometerAlt />, link: '/Dashboard_Hod' },
   
    // { text: 'Onboard Me', icon: <FaUserCircle />, link: '/Onboard_auditor' },
   
   { text: 'Requisition', icon: <FaUserCircle />, link: '/HODRequisitionApproval' },
   
   { text: 'Tasks Management', icon: <FaCalendarAlt />, link: '/TaskManagementHOD' },
    { text: 'Leave Request', icon: <FaCalendarAlt />, link: '/LeaveCalendar_hod' },
    
     { text: 'Change Password', icon: <FaIdBadge />, link: '/PasswordChange_hod' },
  ];

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const handleMenuItemClick = () => setDrawerOpen(false);

  const renderMenuItems = () => (
    <List>
      {menuItems.map((item) => {
        const isSelected = location.pathname === item.link;
        return (
          <ListItem
            button
            component={Link}
            to={item.link}
            key={item.text}
            onClick={handleMenuItemClick}
            sx={{
              backgroundColor: isSelected ? '#37474F' : '#263238',
              boxShadow: isSelected
                ? '0px 4px 12px rgba(0, 0, 0, 0.4)'
                : '0px 2px 6px rgba(0, 0, 0, 0.25)',
              border: '1px solid #455A64',
              borderRadius: '12px',
              paddingY: 2,
              paddingX: 2,
              marginY: 1.2,
              marginX: 1,
              color: '#ECEFF1',
              '&:hover': {
                backgroundColor: '#455A64',
                boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.4)',
              },
            }}
          >
            <Box sx={{ marginRight: 2, fontSize: '1.5rem' }}>{item.icon}</Box>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontSize: '1rem',
                fontWeight: 500,
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );

  return (
    <>
      {/* Mobile menu button */}
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          left: 16,
          zIndex: 1301,
          display: { xs: 'block', sm: 'none' },
        }}
      >
        <IconButton color="inherit" onClick={toggleDrawer} aria-label="Open menu">
          <MenuIcon sx={{ color: 'white' }} />
        </IconButton>
      </Box>

      {/* Drawer for mobile */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            width: 220,
            backgroundColor: '#263238',
            color: 'white',
          },
        }}
      >
        <Box
          sx={{
            width: 220,
            height: '100%',
            backgroundColor: '#263238',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              textAlign: 'center',
              paddingY: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={logo} alt="Logo" style={{ width: 48, height: 48, marginRight: 12 }} />
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.2rem',
                fontWeight: 'bold',
                color: '#ECEFF1',
              }}
            >
            </Typography>
          </Box>
          <Divider sx={{ borderColor: '#455A64', marginBottom: 2 }} />
          {renderMenuItems()}
        </Box>
      </Drawer>

      {/* Sidebar for desktop */}
      <Box
        sx={{
          width: 220,
          height: '160vh',
          backgroundColor: '#263238',
          display: { xs: 'none', sm: 'flex' },
          flexDirection: 'column',
          color: 'white',
          paddingTop: 2,
        }}
      >
        {/* Logo and title */}
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'center',
            py: 2,
            mb: 2,
            boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: 100,
              height: 'auto',
            }}
          />
        </Box>
        <Divider sx={{ borderColor: '#455A64', marginBottom: 2 }} />
        {renderMenuItems()}
      </Box>
    </>
  );
}

export default Sidebar;
